import { MldEcommerceEventParams } from '../events'
import { MldEcommerceProduct, ProductItem } from '../types'

export type ProductItemForEcommerce = Pick<
  ProductItem,
  | 'sku'
  | 'name'
  | 'organization'
  | 'discount'
  | 'index'
  | 'brand'
  | 'category'
  | 'subCategory'
  | 'category3'
  | 'category4'
  | 'category5'
  | 'group'
  | 'locationId'
  | 'salePrice'
  | 'quantity'
  | 'status'
  | 'tags'
>

export const formatProductItemsToEcommerce = (
  items: ProductItemForEcommerce[],
  parameters?: MldEcommerceEventParams['parameters'],
): MldEcommerceProduct[] =>
  items.map((item, index) => ({
    item_id: item.sku,
    item_name: item.name,
    affiliation: item.organization?.name,
    coupon: parameters?.coupon,
    discount: item.discount,
    index: item.index ?? index,
    item_brand: item.brand,
    item_category: item.category,
    item_category2: item.subCategory,
    item_category3: item.category3,
    item_category4: item.category4,
    item_category5: item.category5,
    item_list_id: parameters?.item_list_id,
    item_list_name: parameters?.item_list_name,
    item_variant:
      typeof item.group !== 'undefined' && item.group?.length
        ? Boolean(item.group && item.group.length > 1)
        : undefined,
    location_id: item.locationId,
    price: item.salePrice,
    quantity: item.quantity,
    cd_pronta_entrega:
      typeof item.tags !== 'undefined' && item.tags?.length
        ? Boolean(item.tags?.some((tag) => tag.toLowerCase() === 'pronta-entrega'))
        : undefined,
    cd_preco_re:
      typeof item.tags !== 'undefined' && item.tags?.length
        ? item.tags?.some((tag) => tag === 'Preço do Revendedor')
        : undefined,
    cd_product_status: item.status,
  }))
